/*
 * Until Gatsby Core slightly prunes this list
 * let's do a simple filter to keep them a little more actionable
 */
export const excludeActivitiesList: string[] = [
  `Build manifest and related icons`,
  `write out redirect data`,
  `write out requires`,
  `update schema`,
  `copy gatsby files`,
  `open and validate gatsby-configs`,
]
